module.exports = "./img/9059af248fdb6b6918f348b33debc382.jpg";